export default {
  BASE_URL: "/admin/cms/content",
  api: [
    /** 内容管理 */
    {
      name: "contentList",
      desc: "内容列表",
      method: "POST",
      path: "/contentList"
    },
    {
      name: "contentUpRelease",
      desc: "发布",
      method: "PUT",
      path: "/contentUpRelease"
    },
    {
      name: "contentDel",
      desc: "删除",
      method: "PUT",
      path: "/contentDel"
    },
    {
      name: "detailContent",
      desc: "内容详情",
      method: "GET",
      path: "/detailContent"
    },
    {
      name: "setIsTop",
      desc: "置顶-取消置顶",
      method: "GET",
      path: "/setIsTop"
    },
    {
      name: "getCata",
      desc: "获取所属类目",
      method: "GET",
      path: "/getCata"
    },
    {
      name: "addContent",
      desc: "新增内容详情",
      method: "POST",
      path: "/addContent"
    },
    {
      name: "catalogList",
      desc: "获取二级栏目",
      method: "GET",
      path: "/catalogList"
    },
    {
      name: "addCatalog",
      desc: "新增二级栏目",
      method: "POST",
      path: "/addCatalog"
    },
    {
      name: "delCatalog",
      desc: "删除类目",
      method: "DELETE",
      path: "/delCatalog/{id}"
    },
    {
      name: "upStatus",
      desc: "启用/停用类目状态",
      method: "PUT",
      path: "/upStatus"
    },
    {
      name: "checkName",
      desc: "重名校验",
      method: "POST",
      path: "/checkName"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/cms/content.js